export default "__VITE_ASSET__0355153b__"